import { render, staticRenderFns } from "./AptosTabla.vue?vue&type=template&id=3e2b6f24&scoped=true&"
import script from "./AptosTabla.vue?vue&type=script&lang=js&"
export * from "./AptosTabla.vue?vue&type=script&lang=js&"
import style0 from "./AptosTabla.vue?vue&type=style&index=0&id=3e2b6f24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b6f24",
  null
  
)

export default component.exports